/*
 * Keeps a show-specific catalog path intact.
 * Homepage date link -> collection -> product -> header logo -> same collection.
 */
(() => {
  const PARAM = 'multiloca_location';

  function normalizeId(value) {
    if (value == null) return null;
    if (typeof value === 'object') {
      value = value.locationId ?? value.location_id ?? value.id ?? value.value ?? value.location?.id ?? null;
    }
    const text = String(value ?? '').trim();
    const gid = text.match(/gid:\/\/shopify\/Location\/(\d+)/i);
    return gid ? gid[1] : (/^\d+$/.test(text) ? text : null);
  }

  function selectedLocationId() {
    const urlValue = normalizeId(new URLSearchParams(window.location.search).get(PARAM));
    if (urlValue) return urlValue;
    try {
      const stored = localStorage.getItem('selected_location');
      if (!stored) return null;
      try { return normalizeId(JSON.parse(stored)) || normalizeId(stored); } catch { return normalizeId(stored); }
    } catch {
      return null;
    }
  }

  function withLocation(href, locationId) {
    if (!locationId || !href) return href;
    let url;
    try { url = new URL(href, window.location.origin); } catch { return href; }
    if (url.origin !== window.location.origin) return href;
    url.searchParams.set(PARAM, locationId);
    return `${url.pathname}${url.search}${url.hash}`;
  }

  function updateLinks() {
    const locationId = selectedLocationId();
    if (!locationId) return;

    document.querySelectorAll('a[data-presale-return-to-collection]').forEach((link) => {
      link.href = withLocation(link.getAttribute('href'), locationId);
    });

    document.querySelectorAll('product-card a[href*="/products/"], [data-key] a[href*="/products/"]').forEach((link) => {
      link.href = withLocation(link.getAttribute('href'), locationId);
    });
  }

  document.addEventListener('shopify:section:load', updateLinks);
  document.addEventListener('locationChanged', updateLinks);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateLinks, { once: true });
  else updateLinks();
})();
